import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emToString',
  pure: true,
  standalone: false,
})
export class ToStringPipe implements PipeTransform {
  public transform(input?: { toString: () => string } | null): string {
    return input?.toString() ?? '';
  }
}
